module.exports = __webpack_public_path__ + "static/rights-responsibilities-e23b71814488f1bb98905e9c2a9f8ce4.png";